import * as React from 'react'
import styled from 'styled-components'
import { getApartmentStatus } from 'utils/helper'

export default function Floor1({
  activeApartment,
  changeFloor,
  changeView,
  hLookAt,
  apartments,
  toggleSceneNameFuture,
  isSceneNameFuture,
}) {
  const [elementOnHover, setElementOnHover] = React.useState('')
  const { sceneName, apartmentNumber } = activeApartment

  return (
    <SVG
      id="rakennus_8"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 250 200"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="329.4002"
          y1="188.4726"
          x2="329.4002"
          y2="143.5626"
          gradientTransform="matrix(1, 0, 0, -1, -164.9032, 361.3841)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0102" stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1="329.4002"
          y1="219.4217"
          x2="329.4002"
          y2="174.5117"
          xlinkHref="#linear-gradient"
        />
      </defs>
      <g id="bg">
        <rect className="cls-1" width="250" height="200" />
        <path
          id="bonava"
          className="cls-2"
          d="M195.6822,171.4479a1.45,1.45,0,0,0,.93-1.379c0-.9465-.7506-1.55-1.8767-1.55h-2.7824V174.54h2.7661c1.15,0,2.0318-.62,2.0318-1.6727A1.4165,1.4165,0,0,0,195.6822,171.4479Zm-2.7416-2.0236h1.6972c.563,0,.9792.2774.9792.8159s-.4325.8486-1.02.8486h-1.6564Zm1.7788,4.21h-1.7788v-1.6891l1.7706-.0082c.62,0,1.0445.2938,1.0445.84C195.7557,173.3409,195.3069,173.6347,194.7194,173.6347Zm6.6914-5.2059a3.1091,3.1091,0,1,0,2.88,3.0925A2.8707,2.8707,0,0,0,201.4108,168.4288Zm0,5.2793a2.2029,2.2029,0,1,1,1.8767-2.1786A1.9314,1.9314,0,0,1,201.4108,173.7081Zm8.8211-.84-2.9457-4.3491h-1.0771V174.54h.971v-4.52l3.0681,4.52h.9465v-6.0218h-.9628Zm5.1565-4.3491-2.4072,6.0218h1.02l.5141-1.3381h2.6029l.5141,1.3381h1.0526l-2.4071-6.0218Zm-.5222,3.7942.9547-2.4724.9546,2.4724Zm7.278.8078-1.6564-4.602h-1.069l2.2522,6.0218h.93l2.2358-6.0218h-1.0363Zm6.6661-4.602h-.8894l-2.4071,6.0218h1.02l.514-1.3381h2.603l.514,1.3381h1.0526Zm-1.4116,3.7942.9547-2.4724.9547,2.4724Zm-12.0926-9.0676a2.9637,2.9637,0,0,0-.91-2.1472l-.3559-.357.1048-.1048.0115-.0119a1.9923,1.9923,0,0,0,.5591-1.3982,2.0643,2.0643,0,0,0-2.0175-2.0453l-1.9941,0V159.01h.9675v-.8616h1.011a1.0914,1.0914,0,0,1,1.0655,1.0778,1.0252,1.0252,0,0,1-.2935.7322l-3.1786,3.1791v-2.3962h-.9676v2.504a2.8648,2.8648,0,0,0,.1027.7574l-1.5465,1.5467.6843.6841,1.3021-1.3022a3.0392,3.0392,0,0,0,2.4669,1.3028A2.9919,2.9919,0,0,0,215.3061,163.2452Zm-2.9882,2.0212a2.07,2.07,0,0,1-1.7706-1.0317l2.8088-2.8093.3558.3567.008.0079a2.0211,2.0211,0,0,1-1.402,3.4764Z"
        />
      </g>
      <g id="apartments">
        <g
          onClick={() => changeView(1, 812)}
          onMouseOver={() => setElementOnHover('812')}
          onMouseLeave={() => setElementOnHover('')}
        >
          <polygon
            className={`cls-3 ${
              sceneName === 'scene_Lounatuuli_1krs_as812_B'
                ? 'active-apt'
                : elementOnHover === '812'
                ? 'on-hover'
                : ''
            } ${
              getApartmentStatus(apartments, '812') === 'sold' ? 'bg-gray' : ''
            }`}
            points="91.586 135.2 103.107 135.2 103.107 150.138 171.586 150.138 171.586 188.467 87.003 188.467 87.003 166.467 91.586 166.467 91.586 135.2"
          />
        </g>
        <g
          onClick={() => changeView(1, 811)}
          onMouseOver={() => setElementOnHover('811')}
          onMouseLeave={() => setElementOnHover('')}
        >
          <polygon
            className={`cls-3 ${
              sceneName === 'scene_Lounatuuli_1krs_as811_B'
                ? 'active-apt'
                : elementOnHover === '811'
                ? 'on-hover'
                : ''
            } ${
              getApartmentStatus(apartments, '811') === 'sold' ? 'bg-gray' : ''
            }`}
            points="103.107 120.64 116.086 120.717 116.086 108.55 158.282 108.55 158.282 124.578 171.586 124.578 171.586 150.138 103.107 150.138 103.107 120.64"
          />
        </g>
      </g>
      <g id="levelfloor">
        <rect
          className="cls-4"
          x="53.2017"
          y="12.8"
          width="105.0285"
          height="175.6667"
        />
        <polyline
          className="cls-5"
          points="158.23 169.911 158.23 188.467 171.535 188.467"
        />
        <polyline
          className="cls-5"
          points="171.535 150.138 158.23 150.138 158.23 124.578 171.535 124.578"
        />
        <line
          className="cls-6"
          x1="171.535"
          y1="124.175"
          x2="171.535"
          y2="188.8556"
        />
        <polygon
          className="cls-5"
          points="91.535 135.2 91.535 110.467 53.202 110.467 53.202 80.356 91.535 80.356 91.535 64.578 103.055 64.578 103.055 120.64 103.055 135.2 91.535 135.2"
        />
        <polyline
          className="cls-5"
          points="103.055 120.64 116.035 120.717 116.035 108.55 103.055 108.55"
        />
        <g>
          <line
            className="cls-5"
            x1="91.9378"
            y1="101.735"
            x2="78.278"
            y2="101.735"
          />
          <polyline
            className="cls-5"
            points="91.938 92.802 60.938 92.802 60.938 110.818"
          />
        </g>
        <polyline
          className="cls-5"
          points="158.23 150.138 103.055 150.138 103.055 135.2"
        />
        <line
          className="cls-5"
          x1="116.035"
          y1="108.55"
          x2="158.2302"
          y2="108.55"
        />
        <line
          className="cls-5"
          x1="158.2302"
          y1="80.3556"
          x2="103.0554"
          y2="80.3556"
        />
        <path className="cls-5" d="M86.9517,166.4667v0Z" />
        <polyline
          className="cls-4"
          points="25.702 196.142 25.702 188.467 53.202 188.467"
        />
        <line
          className="cls-4"
          x1="118.8683"
          y1="196.1416"
          x2="118.8683"
          y2="188.4667"
        />
        <polyline
          className="cls-5"
          points="86.952 188.467 86.952 166.467 91.535 166.467 91.535 135.2 91.535 166.467 53.202 166.467"
        />
      </g>
      <g id="elevator">
        <path
          id="plate"
          className="cls-2"
          d="M212.7418,56.73a15.1463,15.1463,0,0,0-15.15,15.15v56.24a15.15,15.15,0,1,0,30.3,0V71.88A15.1463,15.1463,0,0,0,212.7418,56.73Z"
        />
        <path
          className="cls-7"
          d="M212.7418,88.48a11.52,11.52,0,1,0,11.52,11.52A11.523,11.523,0,0,0,212.7418,88.48Z"
        />
        <path
          className="cls-8"
          d="M211.8963,97.9743h-.0224l-1.2432.6714-.1865-.7373,1.5615-.8359h.8252v7.15h-.9346Z"
        />
        <g id="down">
          <path
            className="cls-9"
            d="M212.7368,135.17a6.89,6.89,0,1,1,0-13.78,6.89,6.89,0,1,1,0,13.78Z"
          />
          <path
            className="cls-9"
            d="M212.7368,121.39a6.89,6.89,0,1,0,0,13.78,6.89,6.89,0,1,0,0-13.78Z"
          />
          <path
            className="cls-2"
            d="M217.2418,126.955l.3975.53-4.505,3.0475a.403.403,0,0,1-.53,0l-4.5049-3.0475.3975-.53,4.24,2.7825a.2484.2484,0,0,0,.3975,0Z"
          />
        </g>
        <g id="up" onClick={() => changeFloor('up')}>
          <path
            className="cls-9"
            d="M212.7368,64.815a6.89,6.89,0,1,0,0,13.78,6.89,6.89,0,1,0,0-13.78Z"
          />
          <path
            className="cls-9"
            d="M212.7368,78.595a6.89,6.89,0,1,1,0-13.78,6.89,6.89,0,1,1,0,13.78Z"
          />
          <path
            className="cls-2"
            d="M217.2418,73.03l.3975-.53-4.505-3.0475a.403.403,0,0,0-.53,0L208.0994,72.5l.3975.53,4.24-2.7825a.2484.2484,0,0,1,.3975,0Z"
          />
        </g>
      </g>
      <g id="view">
        {apartmentNumber === 812 && (
          <g id="_812" data-name="812">
            <path
              id="cone"
              className="cls-10"
              d="M167.872,172.9314a7.4913,7.4913,0,0,1-2.89.58,7.2612,7.2612,0,0,1-2.92-.6l-19.46,44.91h43.79Z"
              transform={`rotate(${hLookAt} ${pivots[apartmentNumber][0]} ${pivots[apartmentNumber][1]})`}
            />
            <circle
              id="location"
              className="cls-1"
              cx={`${pivots[apartmentNumber][0]}`}
              cy={`${pivots[apartmentNumber][1]}`}
              r="1.66"
            />
          </g>
        )}
        {apartmentNumber === 811 && (
          <g id="_811" data-name="811">
            <path
              id="cone-2"
              data-name="cone"
              className="cls-11"
              d="M167.872,141.9823a7.4913,7.4913,0,0,1-2.89.58,7.2612,7.2612,0,0,1-2.92-.6l-19.46,44.91h43.79Z"
              transform={`rotate(${hLookAt} ${pivots[apartmentNumber][0]} ${pivots[apartmentNumber][1]})`}
            />
            <circle
              id="location-2"
              data-name="location"
              className="cls-1"
              cx={`${pivots[apartmentNumber][0]}`}
              cy={`${pivots[apartmentNumber][1]}`}
              r="1.66"
            />
          </g>
        )}
      </g>
      <g id="apartmentnr">
        <g
          className={`${
            sceneName === 'scene_Lounatuuli_1krs_as812_B'
              ? 'white-text'
              : elementOnHover === '812'
              ? 'green-text'
              : ''
          } ${
            getApartmentStatus(apartments, '812') === 'sold'
              ? 'text-white-sold'
              : ''
          }`}
          onClick={() => changeView(1, 812)}
          onMouseOver={() => setElementOnHover('812')}
          onMouseLeave={() => setElementOnHover('')}
        >
          <path
            className="cls-2"
            d="M127.76,171.7561a1.3019,1.3019,0,0,1,.9033-1.2188l-.0068-.0215a1.1283,1.1283,0,0,1-.7217-1.0224,1.2754,1.2754,0,0,1,1.4082-1.212,1.1754,1.1754,0,0,1,1.3233,1.1211,1.1564,1.1564,0,0,1-.7491,1.0645v.0215a1.2614,1.2614,0,0,1,.918,1.1758,1.4023,1.4023,0,0,1-1.5478,1.3242C128.3338,172.9885,127.76,172.4211,127.76,171.7561Zm2.4512-.0284c0-.5537-.3848-.8193-1.001-.9941a.9881.9881,0,0,0-.8193.9385.8413.8413,0,0,0,.91.8681A.8241.8241,0,0,0,130.2108,171.7277Zm-1.6944-2.2763c0,.455.3428.7.8682.8408a.8972.8972,0,0,0,.6934-.8272.7072.7072,0,0,0-.77-.7421A.7239.7239,0,0,0,128.5164,169.4514Z"
          />
          <path
            className="cls-2"
            d="M132.744,168.9328H132.73l-.791.4277-.1191-.47.9941-.5322h.5254v4.5527h-.5957Z"
          />
          <path
            className="cls-2"
            d="M134.9979,172.9113v-.3779l.4834-.47c1.1621-1.1065,1.6875-1.6944,1.6943-2.3809a.8117.8117,0,0,0-.9033-.89,1.5526,1.5526,0,0,0-.9668.3847l-.1963-.4336a1.997,1.997,0,0,1,1.2891-.4629,1.2811,1.2811,0,0,1,1.3935,1.3243c0,.8408-.6093,1.5195-1.5683,2.4443l-.3643.3359V172.4h2.0449v.5117Z"
          />
        </g>
        <g
          className={`${
            sceneName === 'scene_Lounatuuli_1krs_as811_B'
              ? 'white-text'
              : elementOnHover === '811'
              ? 'green-text'
              : ''
          } ${
            getApartmentStatus(apartments, '811') === 'sold'
              ? 'text-white-sold'
              : ''
          }`}
          onClick={() => changeView(1, 811)}
          onMouseOver={() => setElementOnHover('811')}
          onMouseLeave={() => setElementOnHover('')}
        >
          <path
            className="cls-2"
            d="M127.3748,131.7932a1.3018,1.3018,0,0,1,.9034-1.2188l-.0069-.0215a1.1281,1.1281,0,0,1-.7216-1.0224,1.2753,1.2753,0,0,1,1.4082-1.2119,1.1752,1.1752,0,0,1,1.3232,1.1211,1.1564,1.1564,0,0,1-.749,1.0644v.0215a1.2613,1.2613,0,0,1,.9179,1.1758,1.4023,1.4023,0,0,1-1.5478,1.3242C127.9491,133.0256,127.3748,132.4582,127.3748,131.7932Zm2.4512-.0284c0-.5537-.3847-.8193-1.001-.9941a.9881.9881,0,0,0-.8193.9385.8414.8414,0,0,0,.91.8681A.824.824,0,0,0,129.826,131.7648Zm-1.6943-2.2763c0,.4551.3428.7.8681.8408a.8972.8972,0,0,0,.6934-.8271.7073.7073,0,0,0-.77-.7422A.7239.7239,0,0,0,128.1317,129.4885Z"
          />
          <path
            className="cls-2"
            d="M132.3592,128.97h-.0136l-.7911.4278-.1191-.47.9941-.5322h.5254v4.5527h-.5957Z"
          />
          <path
            className="cls-2"
            d="M135.951,128.97h-.0146l-.791.4278-.1192-.47.9942-.5322h.5253v4.5527h-.5947Z"
          />
        </g>
      </g>
    </SVG>
  )
}

const pivots = {
  811: [165.102, 137.3823],
  812: [165.102, 168.3314],
}

const SVG = styled.svg`
  .cls-1 {
    fill: #86cfc2;
  }

  .cls-2,
  .cls-8 {
    fill: #004a33;
  }

  .cls-3 {
    fill: #537f6e;
  }

  .cls-4,
  .cls-5,
  .cls-6 {
    fill: none;
  }

  .cls-4,
  .cls-5,
  .cls-6,
  .cls-8 {
    stroke: #004a33;
    stroke-miterlimit: 10;
  }

  .cls-4 {
    stroke-width: 1.5px;
  }

  .cls-5 {
    stroke-width: 0.85px;
  }

  .cls-6 {
    stroke-width: 0.3px;
  }

  .cls-7 {
    fill: #a5dacf;
  }

  .cls-8 {
    stroke-width: 0.75px;
  }

  .cls-9 {
    fill: #65c5b4;
  }

  .cls-10 {
    fill: url(#linear-gradient);
  }

  .cls-11 {
    fill: url(#linear-gradient-2);
  }

  #up:hover {
    cursor: pointer;

    .cls-9 {
      fill: var(--secondary-color);
    }

    .cls-2 {
      fill: var(--green-color);
    }
  }

  .disable-lift-btn {
    cursor: not-allowed;

    .cls-1 {
      fill: var(--grey);
    }

    .cls-6 {
      fill: var(--light);
    }
  }

  .active-apt {
    fill: var(--primary-color);
    cursor: pointer;
  }

  .on-hover {
    fill: var(--secondary-color);
    cursor: pointer;
  }

  .white-text .cls-2 {
    fill: var(--light);
    cursor: pointer;
  }

  .green-text .cls-2 {
    fill: var(--green-color);
    cursor: pointer;
  }

  .switch {
    cursor: pointer;
  }

  .disabled {
    pointer-events: none;
    cursor: not-allowed;
  }

  .bg-gray {
    fill: var(--color-sold);
    pointer-events: none;
  }

  .text-white-sold .cls-6 {
    fill: #fff;
    cursor: pointer;
  }
`
